export default __webpack_public_path__ + "static/media/pantalla_qr.72149506.svg";